import { ChevronRight, Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path: string;
}

const routeLabels: Record<string, string> = {
  '/': 'Dashboard',
  '/members': 'Members',
  '/care-plans': 'Care Plans',
  '/outreach': 'Outreach Center',
  '/authorizations': 'Authorizations',
  '/programs': 'Programs & Pathways',
  '/quality': 'Quality & Compliance',
  '/ai-form': 'AI Form Creation',
};

export default function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbs: BreadcrumbItem[] = [
    { label: 'Home', path: '/' },
  ];

  let currentPath = '';
  pathnames.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const label = routeLabels[currentPath] || segment.charAt(0).toUpperCase() + segment.slice(1);
    breadcrumbs.push({ label, path: currentPath });
  });

  if (breadcrumbs.length === 1) return null;

  return (
    <nav className="flex items-center space-x-2 text-sm mb-4">
      {breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        const isHome = index === 0;

        return (
          <div key={breadcrumb.path} className="flex items-center">
            {index > 0 && (
              <ChevronRight className="w-4 h-4 text-gray-400 mx-2" />
            )}
            {isLast ? (
              <span className="text-gray-900 font-medium flex items-center">
                {isHome && <Home className="w-4 h-4 mr-1" />}
                {breadcrumb.label}
              </span>
            ) : (
              <Link
                to={breadcrumb.path}
                className="text-gray-600 hover:text-purple-600 transition-colors flex items-center"
              >
                {isHome && <Home className="w-4 h-4 mr-1" />}
                {breadcrumb.label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
